import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { MenuItem } from 'primeng/api';

import { CoreModule } from '@app/core/core.module';
import { SharedModule } from '@app/shared/shared.module';

import { CommonModule } from '@angular/common';
import { FinancialData } from '@app/shared/interfaces/data/financial-data.interface';
import { Step } from '@app/shared/interfaces/step.interface';

@Component({
    selector: 'app-main-page',
    standalone: true,
    templateUrl: './main-page.component.html',
    styleUrls: ['./main-page.component.scss'],
    imports: [CommonModule, CoreModule, SharedModule, TranslateModule, RouterModule],
})
export class MainPageComponent implements OnInit {
    @Input() brand = '';
    @Input() model = '';
    @Input() isPortraitDevice: any;
    @Input() isLoading: boolean = true;

    @Input() financialData!: FinancialData;

    isFinancialCartOpen: boolean = false;

    constructor(private translate: TranslateService) {}

    ngOnInit(): void {
        //this.isLoading = false;
        this.isFinancialCartOpen = false;
    }

    //-------------------------//
    //------EVENT METHODS------//
    //-------------------------//

    isOpenedFinancialCart(evento: boolean) {
        this.isFinancialCartOpen = evento;
    }
}
